"use client";

import { ConvexAuthNextjsProvider } from "@convex-dev/auth/nextjs";
import { ReactNode, useMemo } from "react";
import { ConvexReactClient } from "convex/react";
import { AnalyticsIdentity } from "@/components/analytics/analytics-identity";
import { BriefpanelAnalyticsTracker } from "@/components/analytics/briefpanel-analytics-tracker";

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  // Initialize client in React lifecycle to avoid HMR issues
  const convex = useMemo(() => {
    const convexUrl = process.env.NEXT_PUBLIC_CONVEX_URL;

    if (!convexUrl) {
      throw new Error("NEXT_PUBLIC_CONVEX_URL environment variable is not set");
    }

    console.info("Initializing Convex client", {
      urlDomain: convexUrl.replace(/^(https?:\/\/[^/]+).*$/, "$1"),
    });

    return new ConvexReactClient(convexUrl);
  }, []);

  return (
    <ConvexAuthNextjsProvider client={convex}>
      <BriefpanelAnalyticsTracker />
      <AnalyticsIdentity />
      {children}
    </ConvexAuthNextjsProvider>
  );
}
